import React, { useState, useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import DragAndDrop from 'modules/common/components/DragAndDrop';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import useFormValidator from 'useFormValidator';
import InputMask from 'react-input-mask';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import Select from 'react-select';
import NumberFormat from 'react-number-format';
import { customStyle, ucwords } from 'helper';
import CmsContext from "../../../../context/CmsContext";
import BusinessActivityList from '../components/BusinessActivityList';
import * as c from '../constant';
import * as actions from '../actions';
import Citizenship from '../components/Citizenship';

function UpdateModal({
  updateApplication,
  id,
  history,
  getItem,
  getRegionsList,
  getProvinceList,
  getMunicipalityList,
  getBarangayList,
  municipalityList,
  barangayList,
  updating,
  updateList,
  createUploader,

  getVetRegistrationList,
  vetRegistrationList,
}) {
  const cmsContext = useContext(CmsContext);
  const CMS_VARIABLES = cmsContext.findByType("VARIABLES");

  const [formData, setFormData] = useState({
    area: '',
    base_line: '',
    no_of_male_employees: '',
    no_of_female_employees: '',
    no_of_employees: '',
    no_of_employees_residing_manila: '',
    no_of_van: '',
    no_of_truck: '',
    no_of_motorcycle: '',
    region_code: '130000000',
    province_code: '133900000',
    municipality_code: '',
    barangay_code: '',
    street: '',
    zip_code: '',
    location_owned: 0,
    with_tax_incentives: 0,
    tdn_no: '',
    pin_no: '',
    pin_selected: 0, //
    tdn_selected: 0, //
    tax_incentives_attachment_url: '',
    kind_of_ownership: '',
    owners_gender: '',
    tin_no: '',
    dti_no: '',
    sec_no: '',
    cda_no: '',
    monthly_rental: '',
    business_name: '',
    trade_name: '',
    lessor_name: '',
    cellphone_no: '',
    telephone_no: '',
    email_address: '',
    nationality: '',
    incharge_last_name: '',
    incharge_first_name: '',
    incharge_middle_name: '',
    incharge_suffix_name: '',
    main_office_region_code: '130000000',
    main_office_province_code: '133900000',
    main_office_municipality_code: '',
    main_office_barangay_code: '',
    main_office_street: '',
    main_office_zip_code: '',
    activity_type: '',
    activity_type_others: '',
    pinned_geolocation: '',
    is_validated: '',

    // veterinary registration
    veterinary_fee_id: '',
    calculation_details: {},
  });

  const [formDataCalculation, setFormDataCalculation] = useState({});
  const [calculateData, setCalculateData] = useState({});
  const [pinFormat, setPinFormat] = useState(false);

  let commonValidation = {
    kind_of_ownership: 'required',
    owners_gender:
      'required_if:kind_of_ownership=ONE PERSON CORPORATION|required_if:kind_of_ownership=SOLE PROPRIETORSHIP',
    business_name: 'required',
    // tin_no: 'required|tin_no',

    // dti_no: 'required_if:kind_of_ownership=SOLE PROPRIETORSHIP|dti_no',
    // sec_no: 'required_if:kind_of_ownership=CORPORATION|sec_no',
    // cda_no: 'required_if:kind_of_ownership=COOPERATIVE|cda_no',

    dti_no:
      'required_if:kind_of_ownership=SOLE PROPRIETORSHIP|min_5_alphanumeric|max_20_alphanumeric',
    // sec_no: "required_if:kind_of_ownership=CORPORATION|required_if:kind_of_ownership=ONE PERSON CORPORATION|required_if:kind_of_ownership=PARTNERSHIP|sec_no",
    sec_no:
      'required_if:kind_of_ownership=CORPORATION|required_if:kind_of_ownership=ONE PERSON CORPORATION|required_if:kind_of_ownership=PARTNERSHIP|min_5_alphanumeric|max_20_alphanumeric',
    // cda_no: "required_if:kind_of_ownership=COOPERATIVE|cda_no",
    cda_no:
      'required_if:kind_of_ownership=COOPERATIVE|min_5_alphanumeric|max_20_alphanumeric',

    cellphone_no: 'required|cellphone_number',
    // telephone_no: 'required|tel_number',
    telephone_no: 'tel_number',
    email_address: 'required|email',
    municipality_code: 'required',
    barangay_code: 'required',
    street: 'required',
    zip_code: 'required|number',
    incharge_first_name: 'required',
    incharge_last_name: 'required',
    nationality:
      'required_if:kind_of_ownership=ONE PERSON CORPORATION|required_if:kind_of_ownership=PARTNERSHIP|required_if:kind_of_ownership=CORPORATION',
    area: 'required|number',
    base_line: 'required|number',
    no_of_male_employees: 'required|number',
    no_of_female_employees: 'required|number',
    // no_of_employees: 'required|number',
    no_of_employees_residing_manila: 'required|number',
    no_of_van: 'required|number',
    no_of_truck: 'required|number',
    no_of_motorcycle: 'required|number',
    main_office_municipality_code: 'required',
    main_office_barangay_code: 'required',
    main_office_street: 'required',
    main_office_zip_code: 'required|number',

    lessor_name: 'required_if:location_owned=0',
    monthly_rental: 'required_if:location_owned=0',
    with_tax_incentives: 'required',
    tax_incentives_attachment_url: 'required_if:with_tax_incentives=1',
    activity_type: 'required',
  };

  if (
    _.get(formData, 'location_owned') === 1 &&
    _.get(formData, 'pin_selected') === 0
  ) {
    commonValidation = {
      ...commonValidation,
      tdn_no: 'required|rptax_tdn',
    };
  }

  if (
    _.get(formData, 'location_owned') === 1 &&
    _.get(formData, 'pin_selected') === 1
  ) {
    commonValidation = {
      ...commonValidation,
      pin_no: pinFormat ? 'required|rptax_pin' : 'required|rptax_pin_short',
    };
  }

  const validateForm = useFormValidator(formData, commonValidation);

  const validateCalculation = Object.keys(formDataCalculation)
    .map(item => {
      return { [item]: 'required|number' };
    })
    .values();

  const setValidateCalculation = () => {
    // eslint-disable-next-line no-restricted-syntax
    for (const value of validateCalculation) {
      setCalculateData(prevData => ({
        ...prevData,
        ...value,
      }));
    }
  };

  useEffect(() => {
    if (_.get(formData, 'location_owned') === 1) {
      if (_.get(formData, 'pin_selected') === 0) {
        commonValidation = {
          ...commonValidation,
          tdn_no: 'required|rptax_tdn',
        };
      }
      if (_.get(formData, 'pin_selected') === 1) {
        commonValidation = {
          ...commonValidation,
          pin_no: pinFormat ? 'required|rptax_pin' : 'required|rptax_pin_short',
        };
      }
    }

    if (_.get(CMS_VARIABLES, "LGU_NAME") === "Cauayan") {
      commonValidation = {
        ...commonValidation,
        email_address: "email",
        dti_no: "dti_no|min_5_char|max_20_char",
        tdn_no: "required_if:is_tdn_selected=1|tdn_no"
      };
    }

    validateForm.onSetObjectRules(commonValidation);
  }, [
    _.get(formData, 'location_owned'),
    _.get(formData, 'pin_selected'),
    pinFormat,
  ]);

  // useEffect(() => {
  //   if (_.get(formData, 'location_owned') === 1) {
  //     if (_.get(formData, 'pin_selected') === 0) {
  //       commonValidation = {
  //         ...commonValidation,
  //         tdn_no: 'required|tdn_no',
  //       };
  //     }
  //     if (_.get(formData, 'pin_selected') === 1) {
  //       commonValidation = {
  //         ...commonValidation,
  //         pin_no: 'required_if:pin_selected=1|pin_no',
  //       };
  //     }
  //     validateForm.onSetObjectRules(commonValidation);
  //   }
  // }, [_.get(formData, 'pin_selected')]);

  useEffect(() => {
    setValidateCalculation();
  }, [formDataCalculation]);

  const validateFormCalculation = useFormValidator(
    formDataCalculation,
    calculateData
  );

  useEffect(() => {
    validateFormCalculation.onSetObjectRules(calculateData);
  }, [formDataCalculation]);

  const setModal = useContext(ModalContext);
  const addressList = _.get(updateList, 'included.bplsBusiness.attributes');
  const [municipality, setMunicipality] = useState({
    label: _.get(addressList, 'municipality_name') || '',
    value: _.get(addressList, 'municipality_code') || '',
  });
  const [barangay, setBarangay] = useState({
    label: _.get(addressList, 'barangay_name') || '',
    value: _.get(addressList, 'barangay_code') || '',
  });

  const [mainOfficeMunicipality, setMainOfficeMunicipality] = useState({
    label: _.get(addressList, 'main_office_municipality_name') || '',
    value: _.get(addressList, 'main_office_municipality_code') || '',
  });
  const [mainOfficeBarangay, setMainOfficeBarangay] = useState({
    label: _.get(addressList, 'main_office_barangay_name') || '',
    value: _.get(addressList, 'main_office_barangay_code') || '',
  });

  useEffect(() => {
    getRegionsList();
  }, []);

  useEffect(() => {
    getVetRegistrationList();
  }, []);

  useEffect(() => {
    getProvinceList({
      region_code: _.get(addressList, 'region_code'),
      main_office_region_code: _.get(addressList, 'main_office_region_code'),
    });
  }, []);

  useEffect(() => {
    getMunicipalityList({
      province_code: _.get(addressList, 'province_code'),
      main_office_province_code: _.get(
        addressList,
        'main_office_province_code'
      ),
    });
  }, []);

  useEffect(() => {
    getBarangayList({
      municipality_code: _.get(addressList, 'municipality_code'),
      main_office_municipality_code: _.get(
        addressList,
        'main_office_municipality_code'
      ),
      display_all: 1,
    });
  }, []);

  const calculationDetails = _.get(
    updateList,
    'included.bplsApplication.attributes.calculation_details'
  );

  const handleOnSubmit = e => {
    e.preventDefault();
    if (
      !validateForm.response.is_passed &&
      !validateFormCalculation.response.is_passed
    ) {
      return false;
    }

    const args = {
      ...formData,
      // calculation details
      calculation_details: formDataCalculation,

      // convert string value to int
      no_of_employees: +_.get(formData, 'no_of_employees'),
      no_of_employees_residing_manila: +_.get(
        formData,
        'no_of_employees_residing_manila'
      ),
      no_of_male_employees: +_.get(formData, 'no_of_male_employees'),
      no_of_female_employees: +_.get(formData, 'no_of_female_employees'),
      no_of_vehicles: +_.get(formData, 'no_of_vehicles'),
      no_of_van: +_.get(formData, 'no_of_van'),
      no_of_truck: +_.get(formData, 'no_of_truck'),
      no_of_motorcycle: +_.get(formData, 'no_of_motorcycle'),

      dti_no:
        _.get(formData, 'dti_no') === null
          ? ''
          : _.get(formData, 'dti_no').toUpperCase(),
      sec_no:
        _.get(formData, 'sec_no') === null
          ? ''
          : _.get(formData, 'sec_no').toUpperCase(),
      cda_no:
        _.get(formData, 'cda_no') === null
          ? ''
          : _.get(formData, 'cda_no').toUpperCase(),
      activity_type:
        _.get(formData, 'activity_type') === 'others'
          ? _.get(formData, 'activity_type_others')
          : _.get(formData, 'activity_type'),
      tin_no:
        _.get(formData, 'tin_no') === null ? '' : _.get(formData, 'tin_no'),
      tdn_no:
        _.get(formData, 'tdn_no') === null
          ? ''
          : _.get(formData, 'tdn_no').toUpperCase(),
      pin_no:
        _.get(formData, 'pin_no') === null
          ? ''
          : _.get(formData, 'pin_no').toUpperCase(),
    };

    return updateApplication(id, args, () => {
      const pathName = history.location.pathname;
      setModal({ isOpen: false });
      getItem(id);

      if (pathName.indexOf('/bpls/applications/renewal') > -1) {
        return history.push(`/bpls/applications/renewal/${id}`);
      }
      return history.push(`/bpls/applications/new/${id}`);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  // TODO: find a better or cleaner solution, refactor later
  const checkNumberOfEmployees = employeesData => {
    if (
      _.get(updateList, 'attributes.no_of_employees') === 0 ||
      _.get(updateList, 'attributes.no_of_employees') === '0'
    )
      return '0';
    if (
      _.get(updateList, 'attributes.no_of_employees') !== 0 ||
      _.get(updateList, 'attributes.no_of_employees') !== '0'
    ) {
      if (
        (employeesData === 0 || employeesData === '0') &&
        (_.get(updateList, 'attributes.no_of_male_employees') !== 0 ||
          _.get(updateList, 'attributes.no_of_female_employees') !== 0)
      )
        return '0';
      if (
        (employeesData === 0 || employeesData === '0') &&
        (_.get(updateList, 'attributes.no_of_male_employees') === 0 ||
          _.get(updateList, 'attributes.no_of_female_employees') === 0)
      )
        return '';
    }
    return employeesData;
  };

  useEffect(() => {
    if (!_.isEmpty(updateList)) {
      const business = _.get(updateList, 'included.bplsBusiness.attributes');

      const pinNo = _.get(business, 'pin_no')
        ? _.get(business, 'pin_no').replace(/-/g, '')
        : '';
      const DEFAULT_PIN_LENGTH = 14;
      if (pinNo.length > DEFAULT_PIN_LENGTH) {
        setPinFormat(true);
      }
      if (pinNo.length < DEFAULT_PIN_LENGTH) {
        setPinFormat(false);
      }

      setFormData({
        ...formData,
        area: _.get(business, 'area') || '',
        base_line: _.get(business, 'base_line') || '',

        no_of_employees:
          // eslint-disable-next-line eqeqeq
          _.get(business, 'no_of_employees') == 0
            ? '0'
            : _.get(business, 'no_of_employees') || '',
        // eslint-disable-next-line eqeqeq
        no_of_employees_residing_manila:
          checkNumberOfEmployees(
            _.get(business, 'no_of_employees_residing_manila')
          ) || '',
        no_of_male_employees:
          // eslint-disable-next-line eqeqeq
          _.get(business, 'no_of_employees') == 0
            ? '0'
            : `${_.get(business, 'no_of_male_employees')}` || '',

        no_of_female_employees:
          // eslint-disable-next-line eqeqeq
          _.get(business, 'no_of_employees') == 0
            ? '0'
            : `${_.get(business, 'no_of_female_employees')}` || '',
        no_of_vehicles: _.get(business, 'no_of_vehicles') || '0',
        no_of_van: _.get(business, 'no_of_van') || '0',
        no_of_truck: _.get(business, 'no_of_truck') || '0',
        no_of_motorcycle: _.get(business, 'no_of_motorcycle') || '0',

        region_code: _.get(business, 'region_code') || '',
        province_code: _.get(business, 'province_code') || '',
        municipality_code: _.get(business, 'municipality_code') || '',
        barangay_code: _.get(business, 'barangay_code') || '',
        street: _.get(business, 'street') || '',
        zip_code: _.get(business, 'zip_code') || '',
        location_owned: _.get(business, 'location_owned') || 0,
        with_tax_incentives: !_.isEmpty(
          _.get(business, 'tax_incentives_attachment_url')
        )
          ? 1
          : 0,
        tdn_no: _.get(business, 'tdn_no', '') || '',
        pin_no: _.get(business, 'pin_no', '') || '',
        pin_selected: _.get(business, 'pin_no') ? 1 : 0,
        tax_incentives_attachment_url: _.get(
          business,
          'tax_incentives_attachment_url'
        ),
        kind_of_ownership: _.get(business, 'kind_of_ownership') || '',
        owners_gender: _.get(business, 'owners_gender') || '',
        tin_no: _.get(business, 'tin_no'),
        dti_no: _.get(business, 'dti_no'),
        sec_no: _.get(business, 'sec_no'),
        cda_no: _.get(business, 'cda_no'),
        monthly_rental: _.get(business, 'monthly_rental') || '',
        business_name: _.get(business, 'business_name') || '',
        trade_name: _.get(business, 'trade_name') || '',
        lessor_name: _.get(business, 'lessor_name') || '',
        cellphone_no: _.get(business, 'cellphone_no') || '',
        telephone_no: _.get(business, 'telephone_no') || '',
        email_address: _.get(business, 'email_address') || '',
        nationality: _.get(business, 'nationality') || '',
        incharge_last_name: _.get(business, 'incharge_last_name') || '',
        incharge_first_name: _.get(business, 'incharge_first_name') || '',
        incharge_middle_name: _.get(business, 'incharge_middle_name') || '',
        incharge_suffix_name: _.get(business, 'incharge_suffix_name') || '',
        main_office_region_code:
          _.get(business, 'main_office_region_code') || '130000000',
        main_office_province_code:
          _.get(business, 'main_office_province_code') || '133900000',
        main_office_municipality_code:
          _.get(business, 'main_office_municipality_code') || '',
        main_office_barangay_code:
          _.get(business, 'main_office_barangay_code') || '',
        main_office_street: _.get(business, 'main_office_street') || '',
        main_office_zip_code: _.get(business, 'main_office_zip_code') || '',
        activity_type: _.get(business, 'activity_type') || '',
        pinned_geolocation:
          _.get(business, 'pinned_geolocation') || '14.5964957,120.9445404',
        is_validated: _.get(business, 'is_validated'),
        calculation_details: _.get(business, 'calculation_details') || {},
        veterinary_fee_id: _.get(business, 'veterinary_fee_id') || '',
      });
    }

    if (!_.isEmpty(calculationDetails)) {
      setFormDataCalculation({
        ...formDataCalculation,
        ...calculationDetails,
      });
    }
  }, []);

  const createDropdown = list => {
    const newList = [];
    list.map(data => {
      return newList.push({
        label: data.attributes.name,
        value: data.attributes.code,
      });
    });
    return newList;
  };

  const handleMunicipalitySelect = e => {
    setMunicipality(e);
    setFormData({
      ...formData,
      municipality_code: e.value,
      barangay_code: '',
    });
    setBarangay({});
    getBarangayList({ municipality_code: e.value, display_all: 1 });
  };

  const handleBarangaySelect = e => {
    setBarangay(e);
    setFormData({
      ...formData,
      barangay_code: e.value,
    });
    getBarangayList({ municipality_code: e.value, display_all: 1 });
  };

  const handleMainOfficeMunicipalitySelect = e => {
    setMainOfficeMunicipality(e);
    setFormData({
      ...formData,
      main_office_municipality_code: e.value,
      main_office_barangay_code: '',
    });
    setMainOfficeBarangay({});
    getBarangayList({ municipality_code: e.value, display_all: 1 });
  };

  const handleMainOfficeBarangaySelect = e => {
    setMainOfficeBarangay(e);
    setFormData({
      ...formData,
      main_office_barangay_code: e.value,
    });
    getBarangayList({ municipality_code: e.value, display_all: 1 });
  };

  const onChangeRadioLocationOwned = e => {
    if (e.target.checked) {
      setFormData({
        ...formData,
        [e.target.name]: +e.target.value,
        lessor_name: '',
        monthly_rental: '',
        tdn_selected: 1,
      });
    }

    return setFormData({
      ...formData,
      [e.target.name]: +e.target.value,
      pin_no: '',
      tdn_no: '',
      pin_selected: 0,
      tdn_selected: 0,
    });
  };

  const onChangeRadio = e => {
    setFormData({
      ...formData,
      [e.target.name]: +e.target.value,
    });
  };

  const onChangeCheckbox = e => {
    if (e.target.name === 'pin_selected') {
      if (e.target.checked) {
        setFormData(prevForm => ({
          ...prevForm,
          tdn_no: '',
          pin_selected: 1,
          tdn_selected: 0,
        }));
      }

      if (!e.target.checked) {
        setFormData(prevForm => ({
          ...prevForm,
          pin_no: '',
          pin_selected: 0,
          tdn_selected: 1,
        }));
      }
    }

    setFormData({
      ...formData,
      [e.target.name]: e.target.checked === true ? 1 : 0,
    });
  };

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  const onChangeCalculationDetails = e => {
    setFormDataCalculation({
      ...formDataCalculation,
      [e.target.name]: e.target.value,
    });
  };

  const disableOwnersGender = data => {
    if (_.isEmpty(data)) {
      return true;
    }
    if (['PARTNERSHIP', 'CORPORATION', 'COOPERATIVE'].indexOf(data) <= -1) {
      return false;
    }
    return true;
  };

  const handleOnChangeSelect = key => e => {
    if (key === 'kind_of_ownership' && disableOwnersGender(e.value)) {
      setFormData({
        ...formData,
        [key]: e.value,
        owners_gender: '',
      });
    }

    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  const findGenderValue =
    ['PARTNERSHIP', 'CORPORATION', 'COOPERATIVE'].indexOf(
      _.get(formData, 'kind_of_ownership')
    ) > -1
      ? ''
      : c.OWNERS_GENDER.find(
          item => _.get(formData, 'owners_gender') === _.get(item, 'value')
        ) || '';

  const handleOnChangeRadio = e => {
    if (e.target.value !== 'others') {
      setFormData({
        ...formData,
        activity_type: e.target.value,
        activity_type_others: '',
      });
    }

    setFormData({
      ...formData,
      activity_type: e.target.value,
    });
  };

  useEffect(() => {
    validateForm.validate();
    // }, [Object.values(formData)]);
  }, [Object.values(formData).join(',')]);

  useEffect(() => {
    validateFormCalculation.validate();
  }, []);

  const onChangePhoto = key => data => {
    setFormData({
      ...formData,
      [key]: data.cdnUrl,
    });
  };

  // vet reg filter dropdown
  const listOption =
    vetRegistrationList.map(item => ({
      label: _.get(item, 'attributes.veterinary_registration'),
      value: _.get(item, 'id'),
    })) || '';

  const addedData = {
    label: 'Select',
    value: '',
  };

  const sortOption = (listOption || []).concat([addedData]);
  const vetRegistrationListOption = _.orderBy(sortOption, ['value'], ['asc']);

  const handlePinFormat = e => {
    const pinNo = formData.pin_no.replace(/-/g, '');
    const DEFAULT_PIN_LENGTH = 14;

    if (e.target.checked) {
      setPinFormat(true);
    }

    if (!e.target.checked) {
      if (pinNo.length > DEFAULT_PIN_LENGTH) {
        const remainder = DEFAULT_PIN_LENGTH - pinNo.length; // return negative value
        const newPinNo = pinNo.slice(0, remainder); // remove excess pin_no if user switch to default format (after typing from 19 digit format)

        setFormData({
          ...formData,
          pin_no: newPinNo.replace(
            /(\d{3,3})(\d{2,2})(\d{3,3})(\d{3,3})(\d{3,3})$/,
            '$1-$2-$3-$4-$5'
          ), // format pin_no into (000-00-000-000-000)
        });
      }

      setPinFormat(false);
    }
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row ml-auto text-primary font-weight-bold mb-2">
          Business Information and Registration
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Business Type: {validateForm.renderMessage('kind_of_ownership')}
              </label>
              <Select
                name="kind_of_ownership"
                placeholder="Select Module"
                onChange={handleOnChangeSelect('kind_of_ownership')}
                options={c.KIND_OF_OWNERSHIP}
                value={
                  c.KIND_OF_OWNERSHIP.find(
                    item =>
                      _.get(formData, 'kind_of_ownership') ===
                      _.get(item, 'value')
                  ) || ''
                }
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Owners Gender: {validateForm.renderMessage('owners_gender')}
                {['PARTNERSHIP', 'CORPORATION', 'COOPERATIVE'].indexOf(
                  _.get(formData, 'kind_of_ownership')
                ) > -1
                  ? ' (Not Applicable)'
                  : ''}
              </label>
              <Select
                isDisabled={disableOwnersGender(
                  _.get(formData, 'kind_of_ownership')
                )}
                isClearable
                name="owners_gender"
                placeholder="Select Gender"
                onChange={handleOnChangeSelect('owners_gender')}
                options={c.OWNERS_GENDER}
                value={findGenderValue}
              />
            </div>
            {formData.kind_of_ownership === 'SOLE PROPRIETORSHIP' && (
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-0">
                  DTI Registration Number:{' '}
                  {validateForm.renderMessage('dti_no')}
                </label>
                <input
                  className="form-control"
                  // placeholder="AA000000000"
                  type="text"
                  name="dti_no"
                  style={{ textTransform: 'uppercase' }}
                  onChange={onChange}
                  value={_.get(formData, 'dti_no') || ''}
                />
              </div>
            )}
            {['ONE PERSON CORPORATION', 'PARTNERSHIP', 'CORPORATION'].indexOf(
              _.get(formData, 'kind_of_ownership')
            ) > -1 && (
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-0">
                  SEC Registration Number:{' '}
                  {validateForm.renderMessage('sec_no')}
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="sec_no"
                  style={{ textTransform: 'uppercase' }}
                  onChange={onChange}
                  value={_.get(formData, 'sec_no') || ''}
                />
              </div>
            )}
            {formData.kind_of_ownership === 'COOPERATIVE' && (
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-0">
                  CDA Registration Number:{' '}
                  {validateForm.renderMessage('cda_no')}
                </label>
                <input
                  className="form-control"
                  // placeholder="AA000000000"
                  type="text"
                  name="cda_no"
                  style={{ textTransform: 'uppercase' }}
                  onChange={onChange}
                  value={_.get(formData, 'cda_no') || ''}
                />
              </div>
            )}

            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Tax Identification Number:
                {/* {validateForm.renderMessage('tin_no')} */}
              </label>
              <InputMask
                className="form-control"
                mask="999-999-999-999"
                alwaysShowMask={false}
                type="text"
                name="tin_no"
                onChange={onChange}
                value={_.get(formData, 'tin_no') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Business Name: {validateForm.renderMessage('business_name')}
              </label>
              <input
                className="form-control"
                type="text"
                name="business_name"
                onChange={onChange}
                value={_.get(formData, 'business_name') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Trade Name / Franchise (If Applicable) :
              </label>
              <input
                className="form-control"
                type="text"
                name="trade_name"
                onChange={onChange}
                value={_.get(formData, 'trade_name') || ''}
              />
            </div>

            {/* owner's/president's name */}
            <div className="container pl-0">
              <div className="row ml-auto text-primary font-weight-bold mb-2">
                President&apos;s Name / Owner&apos;s Name
              </div>
              <div className="container-fluid">
                <div className="row">
                  <div className="col-6 form-group">
                    <label htmlFor="last_name" className="form-label mb-0">
                      Last Name:{' '}
                      {validateForm.renderMessage('incharge_last_name')}
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="incharge_last_name"
                      onChange={onChange}
                      value={_.get(formData, 'incharge_last_name') || ''}
                    />
                  </div>
                  <div className="col-6 form-group">
                    <label htmlFor="last_name" className="form-label mb-0">
                      First Name:{' '}
                      {validateForm.renderMessage('incharge_first_name')}
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="incharge_first_name"
                      onChange={onChange}
                      value={_.get(formData, 'incharge_first_name') || ''}
                    />
                  </div>
                  <div className="col-6 form-group">
                    <label htmlFor="last_name" className="form-label mb-0">
                      Middle Name
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="incharge_middle_name"
                      onChange={onChange}
                      value={_.get(formData, 'incharge_middle_name') || ''}
                    />
                  </div>
                  <div className="col-6 form-group">
                    <label htmlFor="last_name" className="form-label mb-0">
                      Suffix
                    </label>
                    <Select
                      name="incharge_suffix_name"
                      placeholder="Select Suffix Name"
                      onChange={handleOnChangeSelect('incharge_suffix_name')}
                      options={c.EXTENSION_NAMES}
                      value={
                        c.EXTENSION_NAMES.find(
                          item =>
                            _.get(formData, 'incharge_suffix_name') ===
                            _.get(item, 'value')
                        ) || ''
                      }
                    />
                  </div>
                  {(formData.kind_of_ownership === 'CORPORATION' ||
                    formData.kind_of_ownership === 'ONE PERSON CORPORATION' ||
                    formData.kind_of_ownership === 'PARTNERSHIP' || 
                    formData.kind_of_ownership === 'COOPERATIVE') && (
                    <div className="col-6 form-group">
                      <label className="form-label mb-0">
                        Nationality: {validateForm.renderMessage('nationality')}
                      </label>
                      <Citizenship
                        name="nationality"
                        onChange={onChange}
                        value={_.get(formData, 'nationality') || ''}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* contact info */}
            <div className="container">
              <div className="row text-primary font-weight-bold mb-2">
                Contact Information
              </div>
              <div className="row">
                <div className="col-6 form-group">
                  <label className="form-label mb-0">
                    E-mail Address:{' '}
                    {validateForm.renderMessage('email_address')}
                  </label>
                  <input
                    className="form-control"
                    type="email"
                    name="email_address"
                    onChange={onChange}
                    value={_.get(formData, 'email_address') || ''}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Mobile Number: {validateForm.renderMessage('cellphone_no')}
                  </label>
                  <InputMask
                    className="form-control"
                    mask="999999999999"
                    alwaysShowMask
                    type="text"
                    name="cellphone_no"
                    onChange={onChange}
                    value={_.get(formData, 'cellphone_no') || ''}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Telephone Number:{' '}
                    {validateForm.renderMessage('telephone_no')}
                  </label>
                  <InputMask
                    className="form-control"
                    mask="99-9999-9999"
                    alwaysShowMask={false}
                    type="text"
                    name="telephone_no"
                    onChange={onChange}
                    value={_.get(formData, 'telephone_no') || ''}
                  />
                </div>
              </div>
            </div>

            {/* business address */}
            <div className="container">
              <div className="row text-primary font-weight-bold mb-2">
                Business Address
              </div>
              <div className="row p-2">
                <div className="col-6 form-group">
                  <label className="form-label mb-0">
                    Select District:{' '}
                    {validateForm.renderMessage(
                      'main_office_municipality_code'
                    )}
                  </label>
                  <div>
                    <Select
                      options={createDropdown(municipalityList)}
                      styles={customStyle}
                      placeholder="Select Municipality"
                      value={mainOfficeMunicipality}
                      onChange={e => {
                        handleMainOfficeMunicipalitySelect(e);
                      }}
                    />
                  </div>
                </div>
                <div className="col-6 form-group">
                  <label className="form-label mb-0">
                    Select Barangay:{' '}
                    {validateForm.renderMessage('main_office_barangay_code')}
                  </label>
                  <div>
                    <Select
                      options={createDropdown(barangayList)}
                      styles={customStyle}
                      placeholder="Select Barangay"
                      value={mainOfficeBarangay}
                      onChange={e => {
                        handleMainOfficeBarangaySelect(e);
                      }}
                    />
                  </div>
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Unit/Room Number/Floor, Building Name, House Number, Street
                    Name: {validateForm.renderMessage('main_office_street')}
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name="main_office_street"
                    onChange={onChange}
                    value={_.get(formData, 'main_office_street') || ''}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Zip Code:{' '}
                    {validateForm.renderMessage('main_office_zip_code')}
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    mask="9999"
                    name="main_office_zip_code"
                    onChange={onChange}
                    value={_.get(formData, 'main_office_zip_code') || ''}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row ml-auto text-primary font-weight-bold mb-2">
          Business Operation
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Business Area/Total Floor Area (sq.m):{' '}
                {validateForm.renderMessage('area')}
              </label>
              <input
                className="form-control"
                type="text"
                name="area"
                onChange={onChange}
                value={_.get(formData, 'area') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Number of Employees residing within Manila:{' '}
                {validateForm.renderMessage('no_of_employees_residing_manila')}
              </label>
              <input
                className="form-control"
                type="text"
                name="no_of_employees_residing_manila"
                onChange={onChange}
                value={_.get(formData, 'no_of_employees_residing_manila') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Total Number of Male Employees:{' '}
                {validateForm.renderMessage('no_of_male_employees')}
              </label>
              <input
                className="form-control"
                type="text"
                name="no_of_male_employees"
                onChange={onChange}
                value={_.get(formData, 'no_of_male_employees') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Total Number of Female Employees:{' '}
                {validateForm.renderMessage('no_of_female_employees')}
              </label>
              <input
                className="form-control"
                type="text"
                name="no_of_female_employees"
                onChange={onChange}
                value={_.get(formData, 'no_of_female_employees') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Number of Van Delivery Vehicle: (if applicable):{' '}
                {validateForm.renderMessage('no_of_van')}
              </label>
              <input
                className="form-control"
                type="text"
                name="no_of_van"
                onChange={onChange}
                value={_.get(formData, 'no_of_van') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Number of Truck Delivery Vehicle: (if applicable):{' '}
                {validateForm.renderMessage('no_of_truck')}
              </label>
              <input
                className="form-control"
                type="text"
                name="no_of_truck"
                onChange={onChange}
                value={_.get(formData, 'no_of_truck') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Number of Motorcycle Delivery Vehicle: (if applicable):{' '}
                {validateForm.renderMessage('no_of_motorcycle')}
              </label>
              <input
                className="form-control"
                type="text"
                name="no_of_motorcycle"
                onChange={onChange}
                value={_.get(formData, 'no_of_motorcycle') || ''}
              />
            </div>
          </div>
        </div>
        <div className="row ml-auto text-primary font-weight-bold mb-2">
          Taxpayer&apos;s Address
        </div>
        <div className="container-fluid">
          <div className="row p-2">
            <div className="col-6 form-group">
              <label className="form-label mb-0">
                Select District:{' '}
                {validateForm.renderMessage('municipality_code')}
              </label>
              <div>
                <Select
                  options={createDropdown(municipalityList)}
                  styles={customStyle}
                  placeholder="Select Municipality"
                  value={municipality}
                  onChange={e => {
                    handleMunicipalitySelect(e);
                  }}
                />
              </div>
            </div>
            <div className="col-6 form-group">
              <label className="form-label mb-0">
                Select Barangay: {validateForm.renderMessage('barangay_code')}
              </label>
              <div>
                <Select
                  options={createDropdown(barangayList)}
                  styles={customStyle}
                  placeholder="Select Barangay"
                  value={barangay}
                  onChange={e => {
                    handleBarangaySelect(e);
                  }}
                />
              </div>
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Unit/Room Number/Floor, Building Name, House Number, Street
                Name: {validateForm.renderMessage('street')}
              </label>
              <input
                className="form-control"
                type="text"
                name="street"
                onChange={onChange}
                value={_.get(formData, 'street') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Zip Code: {validateForm.renderMessage('zip_code')}
              </label>
              <input
                className="form-control"
                mask="9999"
                type="text"
                name="zip_code"
                onChange={onChange}
                value={_.get(formData, 'zip_code') || ''}
              />
            </div>
            <div className="col-6 form-group mb-0 pb-0">
              <div className="d-flex flex-row align-items-center justify-content-between">
                <label htmlFor="last_name" className="form-label mr-2 mb-1">
                  Owned?
                </label>
                <div className="d-flex flex-row justify-content-center px-0 mx-0">
                  <div className="d-flex align-items-center">
                    <input
                      type="radio"
                      name="location_owned"
                      style={{ width: '20px', height: '20px' }}
                      onChange={onChangeRadioLocationOwned}
                      checked={_.get(formData, 'location_owned') === 1}
                      value="1"
                    />
                    <label className="full-label mb-0 mx-1">Yes</label>
                  </div>
                  <div className="d-flex align-items-center mr-2">
                    <input
                      type="radio"
                      name="location_owned"
                      style={{ width: '20px', height: '20px' }}
                      onChange={onChangeRadioLocationOwned}
                      checked={_.get(formData, 'location_owned') === 0}
                      value="0"
                    />
                    <label className="full-label mb-0 mx-1">No</label>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-6 form-group" />{' '}
            {/* placeholder only to avoid collapsing of ONWED? input */}
            {formData.location_owned === 1 ? (
              <div className="col-6 form-group">
                <div className="row d-flex align-items-center justify-content-between">
                  <div className="col-6">
                    <label className="form-label ">
                      {_.get(formData, 'pin_selected') !== 1
                        ? 'Tax Declaration No.'
                        : 'Property Identification No.'}{' '}
                      {_.get(formData, 'pin_selected') !== 1
                        ? validateForm.renderMessage('tdn_no')
                        : validateForm.renderMessage('pin_no')}
                    </label>
                  </div>
                  <div className="col-6 text-right">
                    {_.get(formData, 'pin_selected') ? (
                      <label className="form-label ">
                        19-digit Format:
                        <input
                          name="pinFormat"
                          type="checkbox"
                          checked={pinFormat}
                          onChange={handlePinFormat}
                          className="mx-2 mb-2"
                        />
                      </label>
                    ) : null}
                    <label className="form-label">PIN:</label>
                    {/* checkbox */}
                    <input
                      className="mx-2 mb-2"
                      type="checkbox"
                      name="pin_selected"
                      onChange={onChangeCheckbox}
                      checked={_.get(formData, 'pin_selected')}
                    />
                  </div>
                </div>
                {/* input */}
                <InputMask
                  className="form-control"
                  placeholder={
                    /* eslint-disable no-nested-ternary */
                    _.get(formData, 'pin_selected')
                      ? pinFormat
                        ? 'ex. 000-00-000-000-000-A0000'
                        : 'ex. 000-00-000-000-000'
                      : 'ex. AD-00000-00000'
                  }
                  mask={
                    /* eslint-disable no-nested-ternary */
                    _.get(formData, 'pin_selected')
                      ? pinFormat
                        ? '999-99-999-999-999-a9999'
                        : '999-99-999-999-999'
                      : 'aa-99999-99999'
                  }
                  alwaysShowMask={false}
                  maskChar=""
                  type="text"
                  name={
                    _.get(formData, 'pin_selected') !== 1 ? 'tdn_no' : 'pin_no'
                  }
                  id={
                    _.get(formData, 'pin_selected') !== 1 ? 'tdn_no' : 'pin_no'
                  }
                  onChange={onChange}
                  value={
                    _.get(formData, 'pin_selected') !== 1
                      ? _.get(formData, 'tdn_no', '').toUpperCase()
                      : _.get(formData, 'pin_no', '').toUpperCase() || ''
                  }
                />
              </div>
            ) : (
              /* {formData.location_owned === 1 ? (
                <div className="col-6 form-group">
                  <label className="col-10 form-label mb-1">
                    {checkFormat
                      ? 'Property Identification No.'
                      : 'Tax Declaration No.'}{' '}
                    {checkFormat && validateForm.renderMessage('tdn_no')}
                    {!checkFormat && validateForm.renderMessage('pin_no')}
                  </label>
                  <label className="col-1 form-label align-items-center justify-content-end mb-1">
                    Pin:
                  </label>
                  <input
                    className=""
                    type="checkbox"
                    name="checkFormat"
                    onChange={handleOnCheckBox}
                    checked={checkFormat}
                  />
                  {checkFormat && (
                    <InputMask
                      className="form-control"
                      mask="999-999-999-999"
                      alwaysShowMask
                      type="text"
                      name="pin_no"
                      onChange={onChange}
                      value={_.get(formData, 'pin_no') || ''}
                    />
                  )}
                  {!checkFormat && (
                    <InputMask
                      className="form-control"
                      mask="999-999-999-999"
                      alwaysShowMask
                      type="text"
                      name="tdn_no"
                      onChange={onChange}
                      value={_.get(formData, 'tdn_no') || ''}
                    />
                  )}
                </div> */
              <>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Lessor Name (if applicable):{' '}
                    {validateForm.renderMessage('lessor_name')}
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name="lessor_name"
                    onChange={onChange}
                    value={_.get(formData, 'lessor_name') || ''}
                  />
                </div>
                <div className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    Monthly Rental:{' '}
                    {validateForm.renderMessage('monthly_rental')}
                  </label>
                  <NumberFormat
                    name="monthly_rental"
                    id="monthly_rental"
                    placeholder="0"
                    className="form-control"
                    onValueChange={values => {
                      const { floatValue } = values;
                      setFormData({
                        ...formData,
                        monthly_rental: floatValue,
                      });
                    }}
                    /* eslint-disable */
                    isNumericString={true}
                    thousandSeparator={true}
                    allowNegative={true}
                    allowLeadingZeros={true}
                    displayType="input"
                    prefix=""
                    value={`${_.get(formData, 'monthly_rental', '')}` || ''}
                  />
                </div>
              </>
            )}
          </div>
          <div className="row px-2">
            <div className="col-6 form-group py-2">
              <div className="d-flex flex-row align-items-center justify-content-between">
                <label htmlFor="last_name" className="form-label mr-2 mb-1">
                  Tax Incentives from any Government Entity:{' '}
                  {validateForm.renderMessage('with_tax_incentives')}
                </label>
                <div className="d-flex flex-row justify-content-center px-0 mx-0">
                  <div className="d-flex align-items-center mr-2">
                    <input
                      type="radio"
                      name="with_tax_incentives"
                      style={{ width: '20px', height: '20px' }}
                      onChange={onChangeRadio}
                      checked={_.get(formData, 'with_tax_incentives') === 1}
                      value="1"
                    />
                    <label className="full-label mb-0 mx-1">Yes</label>
                  </div>

                  <div className="d-flex align-items-center">
                    <input
                      type="radio"
                      name="with_tax_incentives"
                      style={{ width: '20px', height: '20px' }}
                      onChange={onChangeRadio}
                      checked={_.get(formData, 'with_tax_incentives') === 0}
                      value="0"
                    />
                    <label className="full-label mb-0 mx-1">No</label>
                  </div>
                </div>
              </div>
            </div>
            {formData.with_tax_incentives === 1 ? (
              <div className="col-12 form-group">
                <label htmlFor="last_name" className="form-label mb-0">
                  Tax Incentive{' '}
                  {validateForm.renderMessage('tax_incentives_attachment_url')}
                </label>
                <div className="row d-flex">
                  <div className="col-3">
                    <div className="bg-primary pt-2 rounded text-center">
                      <label className="form-label text-white">Upload</label>
                    </div>
                  </div>
                  <div className="col-12 col-md-8">
                    <div className="form-wrapper p-2">
                      {!_.get(formData, 'tax_incentives_attachment_url') ? (
                        <DragAndDrop
                          onChange={onChangePhoto(
                            'tax_incentives_attachment_url'
                          )}
                          maxSize={2}
                          caption="JPEG. PNG. Maximum size 2MB."
                          label="Upload your Requirements here"
                          fileType="image/jpeg, image/jpg, image/png"
                        />
                      ) : (
                        <div className="bg-dark text-center py-2 pb-5 rounded">
                          <div className="d-flex justify-content-end col-1">
                            {createUploader(
                              {
                                key: 'tax_incentives_attachment_url',
                                label: 'Sketch',
                              },
                              { placeholder: '  ' }
                            )}
                          </div>
                          <img
                            src={
                              !_.isObject(
                                _.get(
                                  formData,
                                  'tax_incentives_attachment_url'
                                ) || ''
                              )
                                ? _.get(
                                    formData,
                                    'tax_incentives_attachment_url'
                                  ) || ImagePlaceholder
                                : _.get(
                                    formData,
                                    'tax_incentives_attachment_url.cdnUrl'
                                  ) || ImagePlaceholder
                            }
                            className="img-fluid shadow-lg"
                            role="presentation"
                            width="70%"
                            alt=""
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
        {/* business calculation details */}
        <div className="container">
          <div className="row text-primary font-weight-bold mb-2">
            Calculation Details
          </div>

          <div className="row">
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Veterinary Registration:{' '}
                {/* {validateForm.renderMessage('veterinary_fee_id')} */}
              </label>
              <Select
                name="kind_of_ownership"
                placeholder="Select"
                onChange={handleOnChangeSelect('veterinary_fee_id')}
                options={vetRegistrationListOption}
                value={
                  vetRegistrationListOption.find(item => {
                    return (
                      `${_.get(formData, 'veterinary_fee_id')}` ===
                      _.get(item, 'value')
                    );
                  }) || ''
                }
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Base Line: {validateForm.renderMessage('base_line')}
              </label>
              <input
                className="form-control"
                type="text"
                name="base_line"
                onChange={onChange}
                value={_.get(formData, 'base_line') || ''}
              />
            </div>
            {Object.entries(formDataCalculation).map((item, i) => {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <div key={i} className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    {ucwords(item[0].replace(/_/g, ' '))}:
                    {validateFormCalculation.renderMessage(`${item[0]}`)}
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name={item[0]}
                    onChange={onChangeCalculationDetails}
                    value={_.get(formDataCalculation, `${item[0]}`)}
                  />
                </div>
              );
            })}
          </div>
        </div>
        <div className="row ml-auto text-primary font-weight-bold my-2">
          Business Activities{' '}
          <span className="px-1">
            {validateForm.renderMessage('activity_type')}
          </span>
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 form-group d-flex flex-row align-items-center justify-content-between px-3 py-2 my-0">
              <input
                type="radio"
                name="activity_type"
                onChange={handleOnChangeRadio}
                checked={_.get(formData, 'activity_type') === 'MAIN OFFICE'}
                value="MAIN OFFICE"
              />
              <label className="form-label pr-3 m-0">Main Office</label>
              <input
                type="radio"
                name="activity_type"
                onChange={handleOnChangeRadio}
                checked={_.get(formData, 'activity_type') === 'BRANCH OFFICE'}
                value="BRANCH OFFICE"
              />
              <label className="form-label pr-3 m-0">Branch Office</label>
              <input
                type="radio"
                name="activity_type"
                onChange={handleOnChangeRadio}
                checked={
                  _.get(formData, 'activity_type') === 'ADMIN OFFICE ONLY'
                }
                value="ADMIN OFFICE ONLY"
              />
              <label className="form-label pr-3 m-0">Admin Office only</label>
              <input
                type="radio"
                name="activity_type"
                onChange={handleOnChangeRadio}
                checked={_.get(formData, 'activity_type') === 'WAREHOUSE'}
                value="WAREHOUSE"
              />
              <label className="form-label pr-3 m-0">Warehouse</label>
              <input
                type="radio"
                name="activity_type"
                onChange={handleOnChangeRadio}
                checked={_.get(formData, 'activity_type') === 'OTHERS'}
                value="OTHERS"
              />
              <label className="form-label pr-3 m-0">Others</label>
              <input
                className="col-4 custom-input"
                disabled={_.get(formData, 'activity_type') !== 'OTHERS'}
                type="text"
                name="activity_type_others"
                onChange={onChange}
                placeholder="Pls specify"
                value={_.get(formData, 'activity_type_others') || ''}
              />
            </div>
          </div>
        </div>
        <BusinessActivityList
          businessId={id}
          pathName={history.location.pathname}
        />
        <div className="d-flex justify-content-center">
          <button
            disabled={
              updating ||
              !validateForm.response.is_passed ||
              !validateFormCalculation.response.is_passed
            }
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Update`}
            </span>{' '}
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  updateApplication: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getItem: PropTypes.instanceOf(Function).isRequired,

  getRegionsList: PropTypes.instanceOf(Function).isRequired,
  getProvinceList: PropTypes.instanceOf(Function).isRequired,
  getMunicipalityList: PropTypes.instanceOf(Function).isRequired,
  getBarangayList: PropTypes.instanceOf(Function).isRequired,

  municipalityList: PropTypes.instanceOf(Array).isRequired,
  barangayList: PropTypes.instanceOf(Array).isRequired,
  updating: PropTypes.bool.isRequired,
  updateList: PropTypes.instanceOf(Object).isRequired,
  createUploader: PropTypes.instanceOf(Function).isRequired,

  getVetRegistrationList: PropTypes.instanceOf(Function).isRequired,
  vetRegistrationList: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  regionsList: _.get(api, `${c.GET_REGION}.list`) || [],
  provinceList: _.get(api, `${c.GET_PROVINCE}.list`) || [],
  municipalityList: _.get(api, `${c.GET_MUNICIPALITIES}.list`) || [],
  barangayList: _.get(api, `${c.GET_BARANGAYS}.list`) || [],

  vetRegistrationList: _.get(api, `${c.GET_VET_REGISTRATION_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateModal);
